import {isOnlineEnv} from './env';
import {getPagePath} from '@/router/routerUtil';
import {LOGIN} from '@/enmus/PageNames';
export const passDomain = isOnlineEnv ? 'passport.baidu.com' : 'passport.qatest.baidu.com';
export const logoutUrl = `//${passDomain}/?logout&u=${location.origin}${getPagePath(LOGIN)}`;
export const passportPwd = isOnlineEnv ? `//${passDomain}/v2/account/password` : `//${passDomain}/v2/?accountchangepwd`;

let isLoaded = false;

export function loadPassportScript() {
    if (isLoaded) {
        return Promise.resolve([null]);
    }
    return new Promise(resolve => {
        const ps = document.createElement('script');
        ps.src = `${location.protocol}//${passDomain}/passApi/js/wrapper.js`;
        document.body.appendChild(ps);
        ps.onload = () => {
            isLoaded = true;
            resolve([null]);
        };
        ps.onerror = e => {
            resolve([e]);
        };
    });
}


